import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Container, Button, Accordion, Form } from 'react-bootstrap';
//icons
import help from '../components/assets/icons/help.svg';

const Help = () => {

  return (
    <>
      <div className="page-heading">
        <h2><img style={{ height: "3rem" }} src={help} />  Help Page</h2>
        <span>Details of how to play on this platform.</span>
      </div>
      <hr/>

      <Container>
        <Row className="help-section">
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>How to add wave token to your wallet? <span className="red-text"> (Required step to interact on platform)</span></Accordion.Header>
              <Accordion.Body>
                <ol>
                  <li>Login first. Click on my profile button on top-right of header. Then copy your wallet address.</li>
                  <li>To get wave token click on <a target="_blank" href="https://testnet.wavesexplorer.com/faucet">https://testnet.wavesexplorer.com/faucet</a>.</li>
                  <li>Entre your wallet address and confirm your not robot.</li>
                  <li>Click on request wave button.</li>
                  <li> After validation you will receive wave on your wallet address.
                    You can confirm the amount in my profile popup.</li>
                </ol>
                <Row>
                  <iframe height="350" src="https://www.youtube.com/embed/_UnxO4lhEWU" title="How to add wave token to your wallet" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>How to buy PANDAS token from "Buy PANDAS Token" page in exchange of that wave tokens? <span className="red-text"> (Required step to interact on platform)</span></Accordion.Header>
              <Accordion.Body>
                <ol>
                  <li>After having sufficient amount of Wave token you can exchange that for PANDAS token from <a href="#" onClick={()=>window.open("/exchange-token", "_blank")}>Buy PANDAS Token</a> page.</li>
                  <li>Enter the amount of wave you want to exchange.</li>
                  <li>Click on Exchange button.</li>
                  <li> After validation you will receive PANDAS token on your wallet.
                    You can confirm the amount in my profile popup.</li>
                </ol>
                <Row>
                  <iframe height="350" src="https://www.youtube.com/embed/ITnBICL330E" title="How to add PANDAS token to your wallet" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>How to Adopt a PANDA NFT?.</Accordion.Header>
              <Accordion.Body>
                <ol>
                  <li>Login first. Then go to <a href="#" onClick={()=>window.open("/adoption", "_blank")}>Adoption</a> page.</li>
                  <li>Click on adopt button.</li>
                  <li>Wait for 120 seconds. <span className="red-text"> (Do not refresh the page.)</span></li>
                  <li>After 120 seconds you will see "Finish Adoption" button. Click on it.</li>
                  <li>After validation you can see your PANDAS NFT in <a href="#" onClick={()=>window.open("/my-collection", "_blank")}>My Collection</a> page.</li>
                </ol>
                <Row>
                  <iframe height="350" src="https://www.youtube.com/embed/PQ_m2yk2Kj0" title="How to Adopt a PANDA NFT" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>How to purchase PANDA NFT from Market?.</Accordion.Header>
              <Accordion.Body>
                <ol>
                  <li>Login first. Then go to <a href="#" onClick={()=>window.open("/market", "_blank")}>Market</a> page.</li>
                  <li>View all 'Open Auctions'.</li>
                  <li>Click on Auction to view details.</li>
                  <li>Click on "Place Bid" button.</li>
                  <li>Enter the bid amount.<span className="red-text"> (Bid amount should be more then Initial price and less then Buyout Price.)</span></li>
                  <li>Click on "Submit" button.</li>
                  <li>Your bid can be visible in <a href="#" onClick={()=>window.open("/my-bids", "_blank")}>My Bids</a> page.</li>
                </ol>
                <Row>
                  <iframe height="350" src="https://www.youtube.com/embed/K9XL12-cFf8" title="How to Adopt a PANDA NFT" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>How to sell your PANDA NFT on Market?.</Accordion.Header>
              <Accordion.Body>
                <ol>
                  <li>Login first. Then go to <a href="#" onClick={()=>window.open("/my-collection", "_blank")}>My Collection</a> page.</li>
                  <li>Click on PANDAS NFT to view details.</li>
                  <li>Click on "Sell" button.</li>
                  <li>Enter the Auction Start Price and Instant Buy Price. The Auction Desription is optional.<span className="red-text"> (Auction Start Price should be less then Instant Buy Price.)</span></li>
                  <li>Click on "Start" button.</li>
                  <li>Your bid can be visible in <a href="#" onClick={()=>window.open("/my-collection", "_blank")}>My Collection</a> page's "In Auction" tab.</li>
                </ol>
                <Row>
                  <iframe height="350" src="https://www.youtube.com/embed/SDLWntxSmiA" title="How to Adopt a PANDA NFT" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Row>

        <br /><br /><br /><br />
      </Container>
    </>
  )
}

export default Help